import React from 'react'

// Antd
import { Divider, Tooltip, Typography } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import '../../styles/flagTooltip.css'

export type ViewHeaderProps = {
  // Band 1 i den gemensamma sidhuvud-grammatiken (#29): kompakt identitet.
  heading: string
  // Beskrivningen bor i en ⓘ-tooltip istället för en egen rad.
  description?: string
  // Valfritt innehåll i högerkanten, i linje med rubriken – t.ex. en väg tillbaka.
  // Raden är redan space-between, så slotten fanns; den saknade bara ett sätt att fyllas.
  extra?: React.ReactNode
}

// Kompakt sidhuvud: H3 (ner från FlagListHeaders H2) + ⓘ-tooltip + divider.
// Frö till #29 — används här bara av brukare-piloten. Rör INTE FlagListHeader.
const ViewHeader: React.FC<ViewHeaderProps> = ({ heading, description, extra }) => {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {heading}
        </Typography.Title>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {extra}
          {description && (
            <Tooltip title={description} overlayClassName="flag-tooltip" overlayStyle={{ maxWidth: 170 }}>
              <InfoCircleOutlined style={{ color: '#1890ff', fontSize: 16, cursor: 'help' }} />
            </Tooltip>
          )}
        </div>
      </div>
      <Divider style={{ margin: '16px 0', borderTopColor: 'rgba(0, 0, 0, 0.15)' }} />
    </div>
  )
}

export default ViewHeader
